import {useQuery} from "@tanstack/react-query";
import {useEffect} from "react";
import {getClaim} from "../services/ClaimService";
import {useLogout} from "./useLogout";

export function useClaim(claimType, claimValue, {enabled = true} = {}) {
    const logout = useLogout();
    const {data, isError, error, isFetching, refetch} = useQuery({
        queryKey: ["claim", claimType, claimValue],
        queryFn: () => getClaim(claimType, claimValue),
        enabled: enabled && claimType != null && claimValue != null,
        retry: false,
    });

    useEffect(() => {
        if (isError && error.response && error.response.status) {
            if (error.response.status === 401) {
                logout();
            }
        }
    }, [isError, error]);

    return [data ?? null, isFetching, refetch];
}
